export default (event) => {
  console.log('do something, the color has changed', event);
};
